import React, { useRef, FocusEvent, Dispatch, SetStateAction } from "react";
import { Form, Button } from "react-bootstrap";
import { ActionHandlerFunction } from "@preveil-api";
import { GlobalConstants, ChangeAuthenticationUIActionTypes } from "src/common";
import { VerificationCode } from "src/components";

type AllProps = {
  reset?: boolean;
  setReset?: Dispatch<SetStateAction<boolean>>;
  handleAction: ActionHandlerFunction;
}

function CurrentTOTPCodeVerificationFormComponent(props: AllProps) {
  const { reset, setReset, handleAction } = props;
  const button_ref = useRef<HTMLButtonElement>(null);
  let secret = "";


  // Description: Validate and set secret code on finished. Auto-submit on valid code
  function handleSetSecretCode(code: string) {
    secret = code;
    const button = button_ref.current;
    const is_valid = code.length === GlobalConstants.CREATE_ACCOUNT_VERIFICATION_CODE_MAX;
    if (!!button) {
      button.disabled = !is_valid;
      is_valid && setTimeout(() => button.focus());
    }
    is_valid && handleSubmit();
  }

  // Description: Handle form submit
  function handleSubmit() {
    handleAction({ actionType: ChangeAuthenticationUIActionTypes.SubmitTOTPVerificationCode, params: secret });
  }

  return <>
    <h3>Verify Your Current Authentication Method</h3>
    <p>Open your Time-based One-Time Password (TOTP) authenticator application.</p>
    <p>Please wait for the code to refresh on the application and then enter the new verification code below.</p>
    <Form onSubmit={(e: FocusEvent<HTMLFormElement>) => {
      e.stopPropagation();
      e.preventDefault();
      handleSubmit();
    }} noValidate>
      <Form.Group className="mb-3">
        <Form.Label>TOTP Verification Code</Form.Label>
        <VerificationCode
          count={GlobalConstants.CREATE_ACCOUNT_VERIFICATION_CODE_MAX}
          reset={reset}
          setReset={setReset}
          handleAction={handleSetSecretCode} />
      </Form.Group>
      <div className="btn-panel">
        <Button type="submit" ref={button_ref} disabled={true}>Continue</Button>
        <Button variant="outline-secondary" type="button"
          onClick={() => handleAction({ actionType: ChangeAuthenticationUIActionTypes.ResetForms })}>Cancel</Button>
      </div>
    </Form>
  </>;
}

export default React.memo(CurrentTOTPCodeVerificationFormComponent);
